// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"0a0104f96b96c00823ea8f99c07b8e73ecc374a8"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "12.3.4";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = "";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[],\"isrRoutes\":[]}";import * as Sentry from '@sentry/capacitor'
import type { ErrorEvent } from '@sentry/core'

import { config } from '@/config'
import { isIgnoredException } from '@/lib/sentry/isIgnoredException'
import { maskSensitiveQueryParams } from '@/lib/sentry/maskSensitiveQueryParams'

import packageJson from '../../package.json'

/** @type {import('@sentry/capacitor').CapacitorOptions} */
const sentryOptions: Sentry.CapacitorOptions = {
  dsn: 'https://2b2c9947a30b4df79e3346d26f1050c3@o268566.ingest.sentry.io/5946968',
  tracesSampleRate: 1.0,
  release: packageJson.version,
  maxBreadcrumbs: 50,
  attachStacktrace: true,
  environment: config.environment,
  dist: process.env.CI_BUILD_NUMBER ?? undefined,
  integrations:
    process.env.NODE_ENV === 'production'
      ? [Sentry.browserTracingIntegration()]
      : [],
  tracePropagationTargets: [
    'localhost',
    /^capacitor:\/\//,
    'capacitor://localhost',
    'http://localhost:*',
    'https://localhost:*',
    'ionic://localhost',
    process?.env?.NEXT_PUBLIC_DOMAIN ?? '',
  ],
  beforeSend(event: ErrorEvent) {
    if (event?.exception?.values?.some(isIgnoredException)) {
      return null
    }
    return maskSensitiveQueryParams(event)
  },
  // URL に載る秘密の値（maskSensitiveQueryParams の対象クエリ）を、ページ読み込み・画面遷移の記録に残さない
  beforeSendTransaction: event => maskSensitiveQueryParams(event),
  beforeBreadcrumb: breadcrumb => maskSensitiveQueryParams(breadcrumb),
}

if (process.env.NODE_ENV !== 'production') {
  sentryOptions.debug = true
}

Sentry.init(sentryOptions)
Sentry.setTag('application', packageJson?.name)
Sentry.setTag('applicationKey', config?.applicationKey)
